import Vue from 'vue';
import { map, cloneDeep } from 'lodash';
import { apolloClient } from '@/plugins/vue-apollo';
import { fetchCatalogItemsQuery, MRO_SEARCH_ITEMS, MRO_CATALOG_GET_PRODUCT_ITEM, MRO_INSERT_INFORMATION_REQUEST, MRO_CATALOG_BY_PK } from '@/store/graphql/queries/cat4mro';
import { MRO_SAVE_SEARCH_WORDS, MRO_SAVE_ITEM_VISIT } from '@/store/graphql/mutations/cat4mro';

const cat4mro = {
  namespaced: true,
  state: {
    search: {
      data: [],
      count: 0,
    },
    catalog: null,
    catalogItemsSearch: {
      data: [],
      count: 0,
    },
    catalogProduct: null,
  },
  actions: {
    search_initial_state({ commit }) {
      commit('SET_CAT4MRO_SEARCH', {
        data: [],
        count: 0,
      });
    },
    async search({ dispatch, commit, state }, filters) {
      try {
        const searchQuery = {
          fetchPolicy: 'network-only',
          query: MRO_SEARCH_ITEMS,
          variables: {
            offset: filters.offset,
            limit: filters.limit,
            keywords: filters.keywords,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          const data = result.data;

          dispatch('saveSearch', filters);

          commit('SET_CAT4MRO_SEARCH', {
            data: data.search_itemsearch,
            count: data.search_itemsearch_aggregate.aggregate.count,
          });
        } else {
          throw new Error('searchCatalogItems data is null');
        }
      } catch (error) {
        window.console.error(error);
      }

      return state.catalogItemsSearch;
    },
    async searchCatalogItems({ commit, state }, filters) {
      try {
        const searchQuery = {
          fetchPolicy: 'network-only',
          query: fetchCatalogItemsQuery,
          variables: {
            catalog: filters.catalog,
            offset: filters.offset,
            limit: filters.limit,
            keyword: filters.keywords,
            published_at_is_null: filters.published_at_is_null,
            price_gte: filters.price_gte,
            price_lte: filters.price_lte,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          const data = result.data;
          commit('SET_CATALOG_SEARCH', {
            data: data.search_item,
            count: data.search_item_aggregate.aggregate.count,
          });
        } else {
          throw new Error('searchCatalogItems data is null');
        }
      } catch (error) {
        window.console.error(error);
      }

      return state.catalogItemsSearch;
    },
    async getProduct({ commit, state }, productId) {
      commit('SET_CATALOG_PRODUCT_DATA', {});
      try {
        const searchQuery = {
          query: MRO_CATALOG_GET_PRODUCT_ITEM,
          variables: {
            productId,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_CATALOG_PRODUCT_DATA', {
            productItem: result.data.item_by_pk,
          });
        } else {
          commit('SET_CATALOG_PRODUCT_DATA', null);
        }
      } catch (error) {
        window.console.error(error);
      }

      return state.catalogProduct;
    },
    async newInformationRequest(store, informationRequest) {
      try {
        const insertMutation = {
          mutation: MRO_INSERT_INFORMATION_REQUEST,
          variables: {
            data: informationRequest,
          },
        };
        await apolloClient.mutate(insertMutation);
      } catch (error) {
        throw new Error(error);
      }
    },
    async getCatalog({ commit }, catalogId) {
      try {
        const insertMutation = {
          mutation: MRO_CATALOG_BY_PK,
          variables: {
            id: catalogId,
          },
        };
        const response = await apolloClient.mutate(insertMutation);
        if (response && response.data) {
          commit('SET_CATALOG', response.data.catalog_by_pk);
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    async saveSearch(store, filters) {
      try {
        const insertMutation = {
          mutation: MRO_SAVE_SEARCH_WORDS,
          variables: {
            words: filters.keywords,
            offset: filters.offset,
            limit: filters.limit,
          },
        };
        await apolloClient.mutate(insertMutation);
      } catch (error) {
        throw new Error(error);
      }
    },
    async saveItemVisit(store, itemId) {
      try {
        const insertMutation = {
          mutation: MRO_SAVE_ITEM_VISIT,
          variables: {
            itemId,
          },
        };
        await apolloClient.mutate(insertMutation);
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_CAT4MRO_SEARCH(state, { data, count }) {
      const mapData = map(data, (searchItem) => {
        const retVal = cloneDeep(searchItem);
        if (searchItem.catalog && searchItem.catalog[0] && searchItem.catalog[0].organization) {
          const organization = searchItem.catalog[0].organization;
          retVal.organizationId = organization.id;
          retVal.organizationName = organization.name;
        }
        return retVal;
      });

      Vue.set(state.search, 'data', mapData);
      Vue.set(state.search, 'count', count);
    },
    SET_CATALOG_SEARCH(state, { data, count }) {
      Vue.set(state.catalogItemsSearch, 'data', data);
      Vue.set(state.catalogItemsSearch, 'count', count);
    },
    SET_CATALOG_PRODUCT_DATA(state, { productItem }) {
      Vue.set(state, 'catalogProduct', productItem);
    },
    SET_CATALOG(state, data) {
      Vue.set(state, 'catalog', data);
    },
  },
  getters: {
    catalogItemInfo: state => state.catalogProduct,
    catalogItemsSearchInfo: state => state.catalogItemsSearch,
    searchInfo: state => state.search,
    catalogInfo: state => state.catalog,
  },
};

export default cat4mro;



// WEBPACK FOOTER //
// ./src/store/modules/buyer/cat4mro.js